import { TextStyle_TextAlignment } from './../../ricos-schema/legacy/wix/rich_content/v1';

import { isTextAlignmentStyle } from './is-text-alignment-style';

const whiteSpace = 'white-space: pre-wrap !important;' as const;

export const getStyleByEnum = (
  textAlignmentValue: unknown
): {
  style: string;
} => {
  const styleProps: string[] = [];

  if (
    isTextAlignmentStyle(textAlignmentValue) &&
    textAlignmentValue !== TextStyle_TextAlignment.AUTO
  ) {
    styleProps.push(`text-align: ${textAlignmentValue.toLowerCase()}`);
  }
  if (textAlignmentValue === TextStyle_TextAlignment.JUSTIFY) {
    styleProps.push(`${whiteSpace}`);
  }

  return {
    style: styleProps.join('; '),
  };
};
